import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import isEqual from 'lodash/isEqual';
import { Dropdown, Input } from '../../components';

import { distanceOptions } from './filtersOptions';
import messages from './messages';
import './styles.css';

class ZipCode extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    virtual: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      distance: {
        zipCode: '',
        miles: '',
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.distance, prevProps.distance) && !this.props.distance) {
      this.setState({ distance: { zipCode: '', miles: '' } });
    }

    const clearedVirtualFlag = !this.props.virtual && prevProps.virtual;
    const hasDataToSend = this.state.distance.zipCode && this.state.distance.miles;
    if (clearedVirtualFlag && hasDataToSend) {
      const { zipCode, miles } = this.state.distance;
      this.props.onChange(null, { name: 'location.distance', value: { zipCode, miles }, id: 'distance' });
    }
  }

  onChange = (e, { name, value, id }) => {
    const distance = { ...this.state.distance };
    distance[name] = value || '';
    if (name === 'miles' && distance.miles === '') {
      distance.zipCode = '';
    }
    this.setState({ distance }, () => {
      if (!this.state.distance.zipCode && !this.state.distance.miles) {
        this.props.onChange(null, { name: 'location.distance', value: {}, id: 'distance' });
      }
      if (this.state.distance.zipCode && this.state.distance.miles) {
        this.props.onChange(null, { name: 'location.distance', value: this.state.distance, id: 'distance' });
      }
    });
  };

  validateUSZipCode = (value) => {
    // US zip codes
    const regex = new RegExp('^\\d{5}(-{0,1}\\d{4})?$');
    return regex.test(value);
  };

  validateCanadianZipCode = (value) => {
    const regex = new RegExp(/^([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i);
    return regex.test(value);
  };

  validateZipCode = (e, { name, value, id }) => {
    e.preventDefault();
    this.setState({ distance: { ...this.state.distance, [name]: value.toUpperCase() } });
    if (value.length === 0 || this.validateUSZipCode(value) || this.validateCanadianZipCode(value.replace(/\s/g, ''))) {
      this.onChange(e, { name, value, id });
    }
  };

  render() {
    const { intl, virtual } = this.props;
    const { miles, zipCode } = this.state.distance;
    const virtualStyle = virtual ? 'zip-code-container-virtual' : '';
    return (
      <div className={`zip-code-container ${virtualStyle}`}>
        <div className="zip-code-miles-container">
          <strong>
            <FormattedMessage {...messages.within} />
          </strong>
          <Dropdown
            placeholder={intl.formatMessage(messages.displaymiles)}
            data-cy="filter-miles"
            clearable
            id="miles"
            className="no-margin"
            name="miles"
            value={virtual ? '' : miles}
            disabled={virtual}
            options={distanceOptions.map((distance) => ({
              key: distance,
              text: distance ? intl.formatMessage(messages.miles, { value: distance }) : intl.formatMessage(messages.displaymiles),
              value: distance,
            }))}
            onChange={this.onChange}
          />
        </div>
        <div className="number-input">
          <strong>
            <FormattedMessage {...messages.outsideof} />
          </strong>
          <Input
            aria-label={intl.formatMessage(messages.postalcode)}
            placeholder={intl.formatMessage(messages.postalcode)}
            data-cy="filter-zipcode"
            name="zipCode"
            className="zip-code-input"
            id="zipCode"
            value={virtual ? '' : zipCode}
            disabled={virtual}
            onChange={this.validateZipCode}
          />
        </div>
      </div>
    );
  }
}
export default injectIntl(ZipCode);
